module.exports = __webpack_public_path__ + "static/media/jash_dalal.f7f07aa0.png";